function resizeBase64Image(
  base64Image: string,
  options?: {
    type?: string;
    maxWidth?: number;
    maxHeight?: number;
    quality?: number;
  }
): Promise<string> {
  const {
    type = 'image/jpeg',
    maxWidth = 512,
    maxHeight = 512,
    quality = 70,
  } = options || {};

  return new Promise<string>((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    img.onload = () => {
      let newWidth = img.width;
      let newHeight = img.height;

      if (newWidth > maxWidth) {
        newWidth = maxWidth;
        newHeight = (img.height * maxWidth) / img.width;
      }

      if (newHeight > maxHeight) {
        newHeight = maxHeight;
        newWidth = (img.width * maxHeight) / img.height;
      }

      canvas.width = newWidth;
      canvas.height = newHeight;

      ctx.drawImage(img, 0, 0, newWidth, newHeight);

      canvas.toBlob(
        (blob) => {
          const reader = new FileReader();
          reader.onload = () => {
            const minifiedBase64 = reader.result as string;
            resolve(minifiedBase64);
          };
          reader.onerror = (err) => {
            reject(err);
          };
          reader.readAsDataURL(blob);
        },
        type,
        quality / 100
      );
    };

    img.onerror = (err) => {
      reject(err);
    };

    img.src = base64Image;
  });
}

export default resizeBase64Image;
